import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaProcessJob from './media-process-job-model'
import {
  delete_mediaProcessJob,
  load_mediaProcessJobs,
  store_mediaProcessJob,
} from './mediaProcessJob-service'

export const LoadMediaProcessJobsAsync = createAsyncThunk<any, any>(
  'composer/load/mediaProcessJob',
  async (params: { uid: string }) => {
    return await load_mediaProcessJobs(params)
  },
)

export const CreateMediaProcessJobAsync = createAsyncThunk<any, any>(
  'composer/create/mediaProcessJob',
  async (params: MediaProcessJob) => {
    return await store_mediaProcessJob(params)
  },
)

export const DeleteMediaProcessJobAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaProcessJob',
  async (params) => {
    return await delete_mediaProcessJob(params)
  },
)
